import React from "react";
import styles from "./SectionShell.module.scss";

const SectionShell = ({ variant = "clear", children, className = "" }) => {
  const variantClass =
    variant === "surface" ? styles.surface : styles.clear;

  return (
    <div
      className={`${styles.shell} ${variantClass} ${className}`.trim()}
      data-section-variant={variant}
    >
      {children}
    </div>
  );
};

export default SectionShell;
